import * as React from "react";
import { forwardRef } from "react";
const SvgIconDelete = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M20 4L4 20" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M4 4L20 20" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgIconDelete);
export { ForwardRef as ReactComponent };